
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LayoutComponent } from "../@evo/layout/layout.component";
import { NcRoutes } from "../@evo/interfaces/nc-route.interface";
import { UserGuardService } from "./pages/Services/user-gaurd.service";
import { UnauthGuardService } from './pages/Services/unauth-gaurd.service';
import { ForceChangeUnauthGuardService } from './pages/Services/force-change-unauth-gaurd.service';

/**
 * NcRoutes contains group of routes
 */
const childrenRoutes: NcRoutes = [
  {
    path: "",
    canActivate: [UserGuardService],
    redirectTo: "dashboards/analytics",
    pathMatch: "full"
  },
  {
     path: "unauthorized",
     canActivate: [UserGuardService],
     loadChildren: () =>
      import("./pages/unauthorized/unauthorized.module").then(m => m.UnauthorizedModule)
  },
  {
    path: "dashboards/analytics",
    canActivate: [UserGuardService],
    // loadChildren: () =>
    //   import("./pages/work-flow-management/task-listing/task-list-module").then(
    //     m => m.TaskListModule
    //   )
    loadChildren: () =>
      import(
        "./pages/dashboards/dashboard-analytics/dashboard-analytics.module"
      ).then(m => m.DashboardAnalyticsModule)
  },

  

  {
    path: "",
    canActivate: [UserGuardService],
    loadChildren: () =>
      import(
        "./pages/dashboards/dashboard-analytics/dashboard-analytics.module"
      ).then(m => m.DashboardAnalyticsModule)
  },



//Begin Ahmad
  {
    path: "user-list",
    canActivate: [UserGuardService],
    loadChildren: () =>
      import("./pages/user/user-setting-listing/user-setting-listing.module").then(
        m => m.UserSettingListingModule
      )
  },

  {
    path: "add-user-setting",
    canActivate: [],
    loadChildren: () =>
      import(
        "./pages/user/add-update-user-setting/add-update-user-setting.module"
      ).then(m => m.AddUpdateUserSettingModule)
  },
  {
    path: "edit-user-setting/:id",
    canActivate: [UserGuardService],
    loadChildren: () =>
      import(
        "./pages/user/add-update-user-setting/add-update-user-setting.module"
      ).then(m => m.AddUpdateUserSettingModule)
  },
  {
    path: "view-user-setting/:id",
    canActivate: [UserGuardService],
    loadChildren: () =>
      import(
        "./pages/user/add-update-user-setting/add-update-user-setting.module"
      ).then(m => m.AddUpdateUserSettingModule)
  },


  {
    path: "role-list",
    canActivate: [UserGuardService],
    loadChildren: () =>
      import("./pages/role/role-setting-listing/role-setting-listing.module").then(
        m => m.RoleSettingListingModule
      )
  },

  {
    path: "add-role-setting",
    canActivate: [],
    loadChildren: () =>
      import(
        "./pages/role/add-update-role-setting/add-update-role-setting.module"
      ).then(m => m.AddUpdateRoleSettingModule)
  },
  {
    path: "edit-role-setting/:id",
    canActivate: [UserGuardService],
    loadChildren: () =>
      import(
        "./pages/role/add-update-role-setting/add-update-role-setting.module"
      ).then(m => m.AddUpdateRoleSettingModule)
  },
  {
    path: "view-role-setting/:id",
    canActivate: [UserGuardService],
    loadChildren: () =>
      import(
        "./pages/role/add-update-role-setting/add-update-role-setting.module"
        ).then(m => m.AddUpdateRoleSettingModule)
  },

  {
    path: "screen-permissions",
    canActivate: [UserGuardService],
    loadChildren: () =>
      import(
        "./pages/screen-permissions/screen-permissions/screen-permissions.module"
      ).then(m => m.ScreenPermissionsModule)
  }, 
  {
    path: "client-list",
    canActivate: [UserGuardService],
    loadChildren: () =>
      import(
        "./pages/client/client-setting-listing/client-setting-listing.module"
      ).then(m => m.ClientSettingListingModule)
  },
  {
    path: "client-balances",
    canActivate: [UserGuardService],
    loadChildren: () =>
      import(
        "./pages/client/client-balances/client-balances.module"
      ).then(m => m.ClientBalancesModule)
  }, 
  {
    path: "client-groups",
    canActivate: [UserGuardService],
    loadChildren: () =>
      import(
        "./pages/sys-codes/sys-codes-listing/sys-codes-listing.module"
      ).then(m => m.SysCodesListingModule)
  }, 

  {
    path: "add-sys-codes",
    canActivate: [],
    loadChildren: () =>
      import(
        "./pages/sys-codes/add-update-sys-codes/add-update-sys-codes.module"
      ).then(m => m.AddUpdateSysCodesModule)
  },
  {
    path: "edit-sys-codes/:id",
    canActivate: [UserGuardService],
    loadChildren: () =>
      import(
        "./pages/sys-codes/add-update-sys-codes/add-update-sys-codes.module"
      ).then(m => m.AddUpdateSysCodesModule)
  },
  {
    path: "view-sys-codes/:id",
    canActivate: [UserGuardService],
    loadChildren: () =>
      import(
        "./pages/sys-codes/add-update-sys-codes/add-update-sys-codes.module"
        ).then(m => m.AddUpdateSysCodesModule)
  },



  {
    path: "transaction-list",
    canActivate: [UserGuardService],
    loadChildren: () =>
      import(
        "./pages/transaction/transaction-setting-listing/transaction-setting-listing.module"
      ).then(m => m.TransactionSettingListingModule)
  },
  {
    path: "statement-of-account",
    canActivate: [UserGuardService],
    loadChildren: () =>
      import(
        "./pages/statement-of-account/statement-of-account-setting-listing/statement-of-account-setting-listing.module"
      ).then(m => m.StatementOfAccountSettingListingModule)
  },
//End Ahmad



  
  /* {
    path: "screen-permissions",
    canActivate: [UserGuardService],
    loadChildren: () =>
      import(
        "./pages/privileges/screen-permissions/screen-permissions.module"
      ).then(m => m.ScreenPermissionsModule)
  }, */
  

  
  
];

const routes: Routes = [
  {
    path: "login",
    canActivate: [UnauthGuardService],
    loadChildren: () =>
      import("./pages/account/login/login.module").then(m => m.LoginModule)
  },
  {
    path: "register",
    loadChildren: () =>
      import("./pages/account/register/register.module").then(
        m => m.RegisterModule
      )
  },
  {
    path: "forgot-password",
    canActivate: [UnauthGuardService],
    loadChildren: () =>
      import("./pages/account/forgot-password/forgot-password.module").then(
        m => m.ForgotPasswordModule
      )
  },
  {
    path: "change-password",
    canActivate: [UserGuardService],
    loadChildren: () =>
      import("./pages/account/change-password/change-password.module").then(
        m => m.ChangePasswordModule
      )
  },
  {
    path: "force-change-password",
    canActivate: [ForceChangeUnauthGuardService],
    loadChildren: () =>
      import("./pages/account/force-change-password/force-change-password.module").then(
        m => m.ForceChangePasswordModule
      )
  },
  {
    path: "resetpassword",
    canActivate: [UnauthGuardService],
    loadChildren: () =>
      import("./pages/account/reset-password/reset-password.module").then(
        m => m.ResetPasswordModule
      )
  },
 

  {
    path: "layout",
    component: LayoutComponent,
    children: childrenRoutes
  },
 
  {
    path: "",
    redirectTo: "login",
    canActivate: [UnauthGuardService],
    pathMatch: "full"
  },
  
  {
    path: "**",
    canActivate: [UnauthGuardService],
    redirectTo: "login",
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: "enabled",
      relativeLinkResolution: "corrected",
      anchorScrolling: "enabled"
    })
  ],
  exports: [RouterModule]
})
/**
 * Main routing module
 */
export class AppRoutingModule {}
